module.exports = __webpack_public_path__ + "img/icon-entradas-salidas.9ee0755b.svg";